export enum ReachHeaderEnum {
	HEADER_REACH_IMPERSONATING = 'X-REACH-IMPERSONATING',
	HEADER_REACH_API_VERSION = 'X-REACH-API-VERSION',
}
